const carouselItems = [
  {
    title: '暑期档 · 动作大片狂欢季',
    desc: '院线热门动作电影集中上映，不卡顿高清观影体验，肾上腺素飙升的视觉盛宴',
    img: 'https://readdy.ai/api/search-image?query=Epic%20cinematic%20action%20scene%20with%20warm%20golden%20dramatic%20lighting%2C%20wide%20cinematic%20composition%2C%20film%20grain%20texture%2C%20professional%20movie%20poster%20aesthetic%2C%20rich%20warm%20color%20palette%2C%20atmospheric%20dramatic%20mood%2C%20no%20text%20no%20people&width=1200&height=600&seq=carousel-action-01&orientation=landscape',
    tag: '热映中',
  },
  {
    title: '经典重温 · 百年影史必看',
    desc: '精选影史百部经典电影大全，高清修复版画质，重温那些感动过我们的银幕时刻',
    img: 'https://readdy.ai/api/search-image?query=Classic%20vintage%20cinema%20atmosphere%20with%20warm%20sepia%20tones%2C%20old%20film%20projector%20light%2C%20cinematic%20nostalgic%20composition%2C%20film%20reel%20texture%2C%20soft%20golden%20glow%2C%20elegant%20timeless%20movie%20aesthetic%2C%20no%20text&width=1200&height=600&seq=carousel-classic-02&orientation=landscape',
    tag: '经典',
  },
  {
    title: '追剧日历 · 热播剧集更新',
    desc: '最新电视剧每日更新追剧表，不错过任何一集精彩剧情，高清不卡顿秒播',
    img: 'https://readdy.ai/api/search-image?query=Modern%20streaming%20entertainment%20concept%20with%20warm%20ambient%20lighting%2C%20cinematic%20composition%2C%20cozy%20viewing%20atmosphere%2C%20soft%20golden%20and%20amber%20tones%2C%20professional%20cinematic%20look%2C%20film%20grain%2C%20no%20text%20no%20people&width=1200&height=600&seq=carousel-drama-03&orientation=landscape',
    tag: '连载中',
  },
  {
    title: '午夜限定 · 恐怖片专场',
    desc: '深夜专属恐怖电影精选，关灯戴耳机沉浸式体验，胆大就来挑战不卡顿秒播',
    img: 'https://readdy.ai/api/search-image?query=Dark%20atmospheric%20horror%20cinema%20scene%20with%20dramatic%20chiaroscuro%20lighting%2C%20deep%20shadows%2C%20selective%20warm%20highlights%2C%20cinematic%20wide%20composition%2C%20mysterious%20suspenseful%20mood%2C%20professional%20film%20aesthetic%2C%20no%20text&width=1200&height=600&seq=carousel-horror-04&orientation=landscape',
    tag: '深夜场',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-100/50">
      <div className="max-w-7xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 text-center mb-3">
          专题精选
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10 md:mb-14">
          编辑精心策划的影视专题，每一期都值得收藏
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {carouselItems.map((item, idx) => (
            <div
              key={idx}
              className="group relative rounded-2xl overflow-hidden aspect-[16/9] md:aspect-[16/8] lg:aspect-[16/7] bg-background-200 cursor-pointer"
            >
              <img
                src={item.img}
                alt={`夜猫电影院专题 ${item.title} - ${item.desc}`}
                className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                loading="lazy"
                onError={(e) => {
                  const target = e.currentTarget;
                  target.style.display = 'none';
                  (target.parentElement as HTMLElement).style.minHeight = '0';
                  (target.parentElement as HTMLElement).classList.add('hidden');
                }}
              />
              <div className="absolute inset-0 bg-gradient-to-t from-background-950/80 via-background-950/20 to-transparent"></div>
              <div className="absolute bottom-0 left-0 right-0 p-6 md:p-8">
                <span className="inline-block px-3 py-1 rounded-full bg-accent-500/90 text-background-50 text-xs font-semibold mb-3 whitespace-nowrap">
                  {item.tag}
                </span>
                <h3 className="text-lg md:text-xl font-heading font-bold text-background-50 mb-2">
                  {item.title}
                </h3>
                <p className="text-sm text-background-50/80 max-w-md">
                  {item.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}